import { faBusSchool, faCloudRainbow, faSchool } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import ldIsEqual from "lodash/isEqual";
import ldPick from "lodash/pick";
import { v4 } from "uuid";

import { AvailableTime } from "./types";

export function makeAvailableTimes(
  from: number,
  to: number,
  days?: number[],
): AvailableTime[] {
  const availableTimes: AvailableTime[] = [];
  const daysToInclude = days || [1, 2, 3, 4, 5]; // default Monday to Friday
  daysToInclude.forEach(day => {
    availableTimes.push({
      uid: v4(),
      day,
      startHour: from,
      startMinute: 0,
      endHour: to,
      endMinute: 0,
    });
  });
  return availableTimes;
}

export enum TimeOfDay {
  Custom = "Custom",
  SchoolHours = "School hours",
  AfterSchool = "After school",
  Anytime = "Anytime",
}

export type TimeOfDayOption = {
  range: [number?, number?];
  icon: any;
  label: TimeOfDay;
  subLabel?: string;
  trackingUniqueId: string;
  days?: number[];
};

export const TIMES_OF_DAY: TimeOfDayOption[] = [
  {
    range: [8, 21],
    icon: faCloudRainbow,
    label: TimeOfDay.Anytime,
    trackingUniqueId: "anytime",
    days: [0, 1, 2, 3, 4, 5, 6],
  },
  {
    range: [8, 16],
    icon: faSchool,
    label: TimeOfDay.SchoolHours,
    trackingUniqueId: "school_hours",
  },
  {
    range: [16, 21],
    icon: faBusSchool,
    label: TimeOfDay.AfterSchool,
    trackingUniqueId: "after_school",
  },
];

export function useTimeOfDayString() {
  const { t } = useTranslation(
    "client\\components\\AvailableTimesInput\\utils",
  );
  return (timeOfDay: TimeOfDay) => {
    switch (timeOfDay) {
      case TimeOfDay.Custom:
        return t("Custom");
      case TimeOfDay.SchoolHours:
        return t("School hours");
      case TimeOfDay.AfterSchool:
        return t("After school");
      case TimeOfDay.Anytime:
        return t("Anytime");
    }
  };
}

export function checkIsSelected(
  availableTimes: AvailableTime[],
  from: number,
  to: number,
  days?: number[],
) {
  const availableTimesToMatch = makeAvailableTimes(from, to, days).map(ea =>
    ldPick(ea, ["day", "startHour", "startMinute", "endHour", "endMinute"]),
  );
  const availableTimesCleaned = availableTimes.map(ea =>
    ldPick(ea, ["day", "startHour", "startMinute", "endHour", "endMinute"]),
  );
  return ldIsEqual(availableTimesToMatch, availableTimesCleaned);
}
